import gerarIdRudimentar from "../../../../helpers/gerarIdRudimentar";

export const initialNodes = [
    {
        id: "perfilroot_techpines",
        type: "Perfil",
        draggable: false,
        selectable: false,
        data: { id: 1, titulo: 'Techpines', color: "0,255,0" },
        position: { x: -200, y: -70 },
    },
    {
        id: gerarIdRudimentar(),
        data: [],
        position: { x: 0, y: 0 },
        type: "Início"
    },
    {
        id: gerarIdRudimentar(),
        data: [],
        position: { x: 500, y: 0 },
        type: "Fim"
    }
]